export default __webpack_public_path__ + "static/media/Logo_Queiroz.bc71499c.png";